import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import ClientService from '../../../../../services/clientmanagement.service';
import ServiceforCityandState from '../../../../../../masterdata/services/masterdata.service';
import ViewDetailsComponent from './../../../../../../shared/components/viewdetails';

export default {
	name: 'clientKYC',
	components: {
		VueElementLoading,
		ViewDetailsComponent
	},
	props: ['viewRow','statelist','selectclientSystemID','selectBusinessAccId'],
	data() {
		return {
			isLoading : false,
			generalInfo : {},
			legelInfo : {},
			spocInfo : {},
			bankInfo : {},
			//statelist : [],
			address1 : '',
			address2 : '',
			firstName : '',
			lastName : '',
			raddress1 : '',
			raddress2 : '',
			generalInfoData : null,
			spocInfoData : null,
			bdlist : null,
			gstTableData:[],
			legalInfoData : null,
			bankInfoData : null,
			expanded:false,
			accordianTab:{1:false, 2:false, 3:false, 4:false, 5:false}
		}
	},
	computed: {},
	async mounted() {
		this.isLoading = true;
		await Promise.all([
			this.getClientInfo(this.viewRow),
			this.getClientBDList(this.selectclientSystemID, this.selectBusinessAccId)
		]);
		this.isLoading = false;
	},
	methods: {
		expandAll(){
			this.expanded = true;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = true;
			}
		},
		collapseAll(){
			this.expanded = false;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = false;
			}
		},
		toggleCheck(tabid){
			this.expanded = false;
			for (var key in this.accordianTab) {
				if(tabid != key){
					this.accordianTab[key] = false;
				}
			}
		},
		getStateName(state) {
      for (var i = 0; i < this.statelist.length; i++) {
        if (this.statelist[i].id == state) {
          return this.statelist[i].label;
        }
      }
    },
		async getCityList(cityid) {
      try {
        let inputPayload = {
          "stateId": [cityid]
        }
        let result = await ServiceforCityandState.getCityList(inputPayload)
        return result.data.data;
      } catch (err) {
        this.citylist = [];
      }
    },
		async getClientBDList(clientid, clientbusinessaccountid){
      try {
				let inputPayload = {
					clientid : clientid,
					clientbusinessaccountid : clientbusinessaccountid
				}
        let result = await ClientService.getClientBDList(inputPayload);
        let tempClientBDList = result.data.data;
        let tempArr = [];
        let tempArr1 = [];
        for (var i = 0; i < tempClientBDList.length; i++) {
					if(tempClientBDList[i].type=="BD"){
						tempArr.push(tempClientBDList[i].bdusername);
					}
					if(tempClientBDList[i].type=="KAM"){
						tempArr1.push(tempClientBDList[i].bdusername);
					}
        }
        this.bdlist = [{
					type: "detail",
					key: "BD Name",
					value: tempArr.join(", ")
				},
				{
					type: "detail",
					key: "KAM Name",
					value: tempArr1.join(", ")
				}
			];
      } catch (e) {
				console.log("e",e);
      }
    },
		async getClientInfo(payload){
			let result = await ClientService.getClientAccountKYCDetails(payload);
			if (result.data.code == 200) {
				let generalInfo = result.data.data.data[0].generalInfo;
				let spocInfo = result.data.data.data[0].clientSPOCInfo;
				let legelInfo = result.data.data.data[0].companyLegalInfo;
				let bankInfo = result.data.data.data[0].clientBankInfo;
				if (await generalInfo.clientAddress != null) {
					let address = await generalInfo.clientAddress.split("+");
					this.address1 = address[0];
					this.address2 = address[1];
				}else {
					this.address1 = '';
					this.address2 = '';
				}
				if (await spocInfo.Name != '') {
					let name = await spocInfo.Name.split("+");
					this.firstName = name[0];
					this.lastName = name[1];
				}else {
					this.firstName = '';
					this.lastName = '';
				}

				if (await legelInfo.companyBusinessAddress != null) {
					let name = await legelInfo.companyBusinessAddress.split("+");
					this.raddress1 = name[0];
					this.raddress2 = name[1];
				}else {
					this.raddress1 = '';
					this.raddress2 = '';
				}

				if (generalInfo.CompanyName != null && generalInfo.clientAddress != null) {
					this.generalInfoData = [{
							type: "detail",
							key: "Company Business/Trade Name",
							value: generalInfo.CompanyName
						},{
							type: "detail",
							key: "Client Website/Domain Name",
							value: generalInfo.CompanyWebsite
						},
						{
							type: "heading",
							key: "Business Address",
							value: [{
									type: "detail",
									key: "Address Line 1",
									value: this.address1
								},
								{
										type: "detail",
										key: "Address Line 2",
										value: this.address2
								},
								{
										type: "label",
										key: "State",
										value: generalInfo.ClientState
								},
								{
										type: "label",
										key: "City",
										value: generalInfo.ClientCity
								},
								{
										type: "label",
										key: "Pincode",
										value: generalInfo.ClientPinCode
								}
							]
						}];
				}else {
					this.generalInfoData = null;
				}
				if (spocInfo.Name != '' && spocInfo.Email != '') {
					this.spocInfoData = [{
		          type: "label",
		          key: "First Name",
		          value: this.firstName
		        },
						{
		          type: "label",
		          key: "Last Name",
		          value: this.lastName
		        },{
		          type: "label",
		          key: "Designation",
		          value: spocInfo.designation
				     },{
		          type: "label",
		          key: "Email ID",
		          value: spocInfo.Email
					   },{
		          type: "label",
		          key: "Mobile Number",
		          value: spocInfo.ContactNo
					   },{
		          type: "label",
		          key: "Phone Number",
		          value: spocInfo.phoneNumber
						},{
						 type: "label",
						 key: "Extension",
						 value: spocInfo.extension
						}]
				}else {
					this.spocInfoData = null;
				}

				if (legelInfo.companyRegisteredName !=null && legelInfo.companyRegisteredPinCode !=null &&
				legelInfo.gstdetails !=null) {
					let gstTableData = [];
					for (var i = 0; i < legelInfo.gstdetails.length; i++) {
						gstTableData.push({
							type: "label",
							key: "State",
							value: this.getStateName(legelInfo.gstdetails[i].RegistrationState)
						},
						{
							type: "label",
							key: "GST Number",
							value: legelInfo.gstdetails[i].RegistrationNumber,
							action: {
								type:'download',
								value: legelInfo.gstdetails[i].FilePath
							}
						},{})
					}
					this.legalInfoData = [{
							type: "detail",
							key: "Company Registered Name",
							value: legelInfo.companyRegisteredName
						},
						{
							type: "heading",
							key: "Registered Address",
							value: [{
									type: "detail",
									key: "Address Line 1",
									value: this.raddress1
								},
								{
										type: "detail",
										key: "Address Line 2",
										value: this.raddress2
								},
								{
										type: "label",
										key: "State",
										value: legelInfo.companyRegisteredStateID
								},
								{
										type: "label",
										key: "City",
										value: legelInfo.companyRegisteredCityID
								},
								{
										type: "label",
										key: "Pincode",
										value: legelInfo.companyRegisteredPinCode
								},
							]
						},
						{
							type: "heading",
							key: "GST Details",
							value: gstTableData
						},
						{
							type: "heading",
							key: "Legal Documents",
							value: [
								{
										type: "labelfordownload",
										key: "Registration Number",
										value: legelInfo.registrationNumber,
										action: {
											type:'download',
											value: legelInfo.registrationNumberFilePath.filePath ? legelInfo.registrationNumberFilePath.filePath[0] : null
										}
								},
								{
										type: "label",
										key: "PAN Number",
										value: legelInfo.panNumber,
										action: {
											type:'download',
											value: legelInfo.panNumberFilePath.filePath ? legelInfo.panNumberFilePath.filePath[0] : null
										}
								},
								{
										type: "label",
										key: "TAN",
										value: legelInfo.tanNumber
								}
							]
						}];
				}else {
					this.legalInfoData = null;
				}

				this.bankInfoData = [{
							type: "label",
							key: "Beneficiary Name",
							value: bankInfo.beneficaryName
						},{
							type: "label",
							key: "Bank Name",
							value: bankInfo.bankName
						},{
							type: "label",
							key: "Bank Branch",
							value: bankInfo.bankBranch
						},{
							type: "label",
							key: "IFSC/RTGS",
							value: bankInfo.ClinetIFSCNumber
						 },
						 {
							type: "label",
							key: "Bank Account Number",
							value: bankInfo.bankAccountNumber
						}
					];
				if(bankInfo.cancelledchequeFilePath.filePath && bankInfo.cancelledchequeFilePath.filePath[0]!=null){
					this.bankInfoData.push(
						{
							type: "label",
							key: "Cancelled Cheque",
							action: {
								type:'download',
								value: bankInfo.cancelledchequeFilePath.filePath[0]
							}
						}
					);
				}else{
					this.bankInfoData.push(
						{
							type: "label",
							key: "Cancelled Cheque"
						}
					);
				}
			}
		},
		eventFromViewDetails(data){
			if(data.type=="download"){
				this.fileview(data.value);
			}
		},
		fileview(index){
			var link = document.createElement('a');
			link.href = index;
			link.setAttribute('target','_blank');
			window.open(index, '_blank');
			link.remove();
			return true;
		 },
	}

}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/client/clientlisting/clienteview/clientKYC/clientKYC.component.js